import { PlusOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import * as React from "react";
import { Link } from "react-router-dom";

type PropsCreateBtnLinkStd = {
  text: string;
  url: string;
  disabled?: boolean;
  tooltip?: React.ReactNode;
};

export const CreateBtnLinkStd: React.FC<PropsCreateBtnLinkStd> = ({
  text,
  url,
  disabled,
  tooltip,
}) => {
  const btn = (
    <Button type="primary" icon={<PlusOutlined />} disabled={disabled}>
      {text}
    </Button>
  );

  const wrappedBtn = disabled ? <span>{btn}</span> : btn;
  const content = disabled ? wrappedBtn : <Link to={url}>{wrappedBtn}</Link>;

  return tooltip ? <Tooltip title={tooltip}>{content}</Tooltip> : content;
};
